export var Flags = {
    logQueries: false,
    showRouterQueryResult: false,
    logServerRequests: false,
};
